import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import {HelperService} from '../../core/services/helper.service';

@Component({
    selector: 'app-single-category',
    templateUrl: './single-category.component.html',
    styleUrls: ['./single-category.component.css'],
    standalone: false
})
export class SingleCategoryComponent implements OnInit {
  category: any = {};
  categoryId = '';
  infoFields: any[];
  subFields: any[];
  // rateParameters: any[];

  constructor(private route: ActivatedRoute,
              private dashboardService: DashboardService,
              public helper: HelperService) { }

  ngOnInit(): void {
    this.route.params.subscribe( params => this.categoryId = params.id);
    this.getCurrentCategoryData();
    this.getAllData();
  }

  getCurrentCategoryData(): void{
    this.dashboardService.getSingleCategory(this.categoryId).subscribe((data) => {
      this.category = data;
    });
  }

  getAllData(): void{
   this.dashboardService.getInfoParamsByCategory(this.categoryId).subscribe(res => {
      this.infoFields = res;
    });
   this.dashboardService.getSubParamsByCategory(this.categoryId).subscribe(res => {
      this.subFields = res;
    });
  }
}
